import { CarnivalTreasureAnimationData } from '@/models/games/carnivalTreasure';
import { RootState } from '@/store/store';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { animationReducer } from './reducer';

export type CommonAnimationData = CarnivalTreasureAnimationData;

export type Animation = {
    HostId: number;
    Animation: CommonAnimationData;
    Last?: CommonAnimationData;
};
export const ANIMATION_KEY = 'app::animation';
export const animationAdapter = createEntityAdapter<Animation, number>({
    selectId: a => a.HostId,
    sortComparer: (a, b) => a.HostId - b.HostId,
});
const initialAnimationState = animationAdapter.getInitialState();
const animationSlice = createSlice({
    name: ANIMATION_KEY,
    initialState: initialAnimationState,
    reducers: animationReducer,
});
export const animationSliceReducer = animationSlice.reducer;
export const animationSliceActions = animationSlice.actions;
const getAnimationSelectors = animationAdapter.getSelectors<RootState>(
    state => state[ANIMATION_KEY]
);
export const getAnimationMainStateById = (state: RootState, hostId: number) => {
    return getAnimationSelectors.selectById(state, hostId)?.Animation;
};
export const getAnimationLastStateById = (state: RootState, hostId: number) => {
    return getAnimationSelectors.selectById(state, hostId)?.Last;
};
